import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class TurmaService {
  constructor(private http: HttpClient, private base: BaseService) {}

  efetivaInscricoes(idTurmas: number[]): Observable<any> {
    const url = this.base.endpoints.turmaEfetiva;
    return this.http.put(url, idTurmas);
  }
}
